import { createFileRoute } from '@tanstack/react-router';
import { MeetingPage } from '@/features/meetings/pages/meeting-page';

/**
 * The call window (COMX-FE-08): a call opens here, in its own small browser window ("Appeler",
 * "Accepter"), or in the tab when the browser blocks the window. Full screen, outside any shell, no
 * chat. Authorization is the API's: the call is read, and the token issued, only for a person
 * allowed to join.
 */
export const Route = createFileRoute('/_auth/calls/$meetingId')({
  component: CallRoute,
});

function CallRoute() {
  const { meetingId } = Route.useParams();
  return <MeetingPage orgId={null} meetingId={meetingId} callWindow />;
}
